export const formatThaiId = (id = "") => {
  const digits = id.replace(/\D/g, ""); // เอาเฉพาะตัวเลข
  if (!digits) return "";

  const parts = [];
  if (digits.length > 0) parts.push(digits.substring(0, 1));
  if (digits.length > 1) parts.push(digits.substring(1, Math.min(5, digits.length)));
  if (digits.length > 5) parts.push(digits.substring(5, Math.min(10, digits.length)));
  if (digits.length > 10) parts.push(digits.substring(10, Math.min(12, digits.length)));
  if (digits.length > 12) parts.push(digits.substring(12, 13));

  return parts.join("-");
};